import {Component, ExistingProvider, forwardRef, Input, ChangeDetectionStrategy} from '@angular/core';
import {NG_VALUE_ACCESSOR} from '@angular/forms';
import * as _ from 'lodash-es';
import {SelectInputComponent} from '../select-input';
import {SelectItem} from '../select-input/select-item';

const SELECT_INPUT_OBJECT_CONTROL_VALUE_ACCESSOR: ExistingProvider = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => SelectInputObjectComponent),
    multi: true
};

@Component({
    selector: 'select-input-object',
    templateUrl: '../select-input/select-input.component.html',
    styleUrls: ['../select-input/select-input.component.scss'],
    providers: [SELECT_INPUT_OBJECT_CONTROL_VALUE_ACCESSOR],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SelectInputObjectComponent extends SelectInputComponent {

    @Input()
    public equalityBy: string;

    protected override getSelectItemByValue(value: any): SelectItem {
        return _.find(this.selectMenuItems, (item: SelectItem) =>
            this.isSelectItemValueEqual(item.value, value)
        );
    }

    protected override submitValue(value: any): void {
        const compareWithSelectItem = (comparingValue: any) =>
            this.isSelectItemValueEqual(this.selectItem && this.selectItem.value, comparingValue);

        const newSelectItem = value && compareWithSelectItem(value)
            ? this.selectItem
            : this.getSelectItemByValue(value);

        if (!compareWithSelectItem(newSelectItem)) {
            this.setSelectItem(newSelectItem);
            this.propagateChange(value);
        }
    }

    private isSelectItemValueEqual(value1: any, value2: any): boolean {
        return !!value1 === !!value2 && (
            this.equalityBy
                ? (value1 && value1[this.equalityBy]) === (value2 && value2[this.equalityBy])
                : _.isEqual(value1, value2)
        );
    }

}
